// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const USER_STROLLERS_ADD_REVIEW = "Ohodno\u0165 ko\u010d\u00edk";
export const USER_STROLLERS_DELETE = "Zma\u017e";
export const USER_STROLLERS_MY_REVIEW = "Moje hodnotenie";
